import { render, staticRenderFns } from "./bullets.vue?vue&type=template&id=51f542a9"
import script from "./bullets.vue?vue&type=script&lang=js"
export * from "./bullets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports